import { useCallback } from 'react';
import { fetchAllJobsInRange } from '../hooks/useStats';
import { BatchRunsTable } from '../components/BatchRunsTable';
import { RequestAnalytics } from '../components/stats';
import type { AnalyticsJob } from '../components/stats';
import type { DateRange } from '../types';

export function OverviewPage() {
  const fetchAnalyticsJobs = useCallback(
    async (range: DateRange): Promise<AnalyticsJob[]> => {
      const jobs = await fetchAllJobsInRange(range);
      return jobs.map((j) => ({
        id: j.job_id,
        scan_id: j.scan_id,
        created_at: j.created_at,
        status: j.status,
        duration_seconds: j.duration_seconds,
        error: j.error,
      }));
    },
    [],
  );

  return (
    <div className="space-y-6">
      {/* Request analytics */}
      <RequestAnalytics fetchJobs={fetchAnalyticsJobs} statsHref="/lightning/stats" />

      {/* Active batches */}
      <BatchRunsTable />
    </div>
  );
}
